import PageNotFound from "@/views/PageNotFound.vue";

export default [
  {
    path: "*",
    name: "404",
    component: PageNotFound
  }
];
